import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';

const Li = styled.li`
  ${(props) => (props.type === 'aside' && css`
    position: relative;
    height: 35px;
  `)}

  ${(props) => (props.type === 'asideIn' && css`
    position: relative;
    width: 100%;
    height: 40px;
    background-color: #fff;
  `)};

  ${(props) => (props.type === 'animation' && css`
    width: 100%;
    height: 40px;
    background-color: #fff;
    position: relative;
  `)}

  ${(props) => (props.type === 'unit' || props.type === 'track') && css`
    border-bottom: 1px solid #e5e5e5;
  `}

  ${(props) => props.type === 'card' && css`
    width: 223px;
    height: 275px;
  `}

  ${(props) => props.type === 'dots' && css`
    width: 10px;
    height: 10px;
    background-color: #bbb;
  `}
`;

export const Item = forwardRef((props, ref) => {
  return (
    <Li type={props.type} ref={ref} act={props.act} choice={props.choice}>{props.children}</Li>
  );
});

Item.propTypes = {
  type : PropTypes.string
};

Item.defaultProps = {
  type : 'aside'
}